import { defineMessages } from 'react-intl'

export default defineMessages({
  editingBadge: {
    id: 'editExpenseReportPresenter.editingBadge',
    defaultMessage: 'Editing',
  },
  successTitle: {
    id: 'editExpenseReportPresenter.successTitle',
    defaultMessage: 'Success',
  },
  successMessage: {
    id: 'editExpenseReportPresenter.successMessage',
    defaultMessage: 'Expense report updated successfully',
  },
  errorTitle: {
    id: 'editExpenseReportPresenter.errorTitle',
    defaultMessage: 'Error',
  },
})
